'use client';

import React from 'react';
import PropTypes from 'prop-types';
import { clientTheme } from '@/config/clientTheme';

const PageLoaderSkeleton = ({ className }) => (
  <div className={['page-loader-skeleton', className].filter(Boolean).join(' ')}>
    <img
      src={clientTheme.assets.loader}
      alt={`${clientTheme.brandName} Loading`}
      className="page-loader-skeleton__image"
    />
  </div>
);

PageLoaderSkeleton.propTypes = {
  className: PropTypes.string,
};

export default PageLoaderSkeleton;
